<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer002">
<p class="drop ParaOverride-1"><span> </span><span class="com-rorohiko-pagestaker-style">iv</span></p>
<div class="auth">
<img alt="author photo" class="i100" src="image/1.jpg"/>
</div>
<p class="drop"><span class="_idGenDropcap-2">D</span>eborah Blake is the author of over a dozen books on modern Witchcraft, including <span class="ital">The Little Book of Cat Magic</span> and <span class="ital">Everyday Witchcraft</span>, as well as the acclaimed <span class="ital">Everyday Witch Tarot</span> and <span class="ital">Everyday Witch Oracle</span> decks. She has also written three paranormal romance and urban fantasy series for Berkley, and her new cozy mystery series launches with <span class="ital">Furbidden Fatality</span> in 2021. Deborah lives in a 130-year-old farmhouse in upstate New York with numerous cats who supervise all her activities, both magical and mundane. She can be found at: DeborahBlakeAuthor.com</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// About.vue?b9c8678a